import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { EprescriberService } from '../../services/eprescriber.service';
import { PatientService } from '../../services/patient.service';
import { SharedService } from '../../services/shared.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SettingsService } from '../../services/settings.service';
import { IEprescriber } from '../../interfaces/ieprescriber';
import { IEprescriberReviewVo } from '../../interfaces/ieprescriber-review-vo';
import { IEprescriberReviewMedicationCheckVo } from '../../interfaces/ieprescriber-review-medication-check-vo';
import { findIndex } from 'rxjs/operators';


@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.css']
})
export class EprescriberApprovalComponent implements OnInit {

  constructor(
    private settingsService: SettingsService,
    private sharedService: SharedService,
    private eprescriberService: EprescriberService,
    private patientService: PatientService,
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService) { }


  eprescriber: any = {
    patientVo: {}
  };

  MarTar: boolean;
  DrugRecordBook: boolean;
  ProductFromEdb: boolean;
  DirectionsChangedSticker: boolean;
  DcMedsPulled: boolean;
  TransmittedProgressNotes: boolean;
  CarePlan: boolean;
  Diet: boolean;
  Lab: boolean;
  XrayUltrasound: boolean;
  Referral: boolean;
  NotifyPOA: boolean;
  CopyAddedToChart: boolean;

  showErrorMessage: boolean;
  errorMessage: string;
  eprescriberId: number;
  ieprescriberReviewMedicationCheckVos: IEprescriberReviewMedicationCheckVo[];
  showSuccessMessage: boolean;
  eprescriberImage: string;
  showLoadingMessage: boolean;

  reportTitle: string = "EPRESCRIBER";
  notes: string = "";
  @ViewChild('openPrintOrderModal', { static: false }) openPrintOrderModalbutton;
  @ViewChild('closePrintOrderModalButton', { static: false }) closePrintOrderModalButton;

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.ieprescriberReviewMedicationCheckVos = [];
    this.loadEprescriber();
  }

  loadEprescriber() {
    this.showLoadingMessage = true;
    this.eprescriberId = Number.parseInt(this.route.snapshot.paramMap.get('id'));
    this.eprescriberService.getEprescriberById(this.eprescriberId, this.sharedService.getUserId())
      .subscribe(data => {
        this.eprescriber = data;
        this.showLoadingMessage = false;
        this.mergeConnectClinicalFromPatientDto(data);

        if (data.eprescriberFileVos.length > 0) {
          this.eprescriberImage = data.eprescriberFileVos[0].pdfBase64File;
          if (this.eprescriberImage == null)
            this.eprescriberImage = this.settingsService.ApiUrl + data.eprescriberFileVos[0].fileName;
        }
      },
        err => this.showLoadingMessage = false);
  }

  save() {
    this.spinnerService.show();

    var resultValidation = this.validateMedicationCheck();
    if (resultValidation) {
      var ieprescriberReviewVo: IEprescriberReviewVo = {
        Id: this.eprescriberId,
        Notes: this.notes,
        ApprovedBy: this.sharedService.getUserId(),
        EprescriberReviewMedicationCheckVos: this.ieprescriberReviewMedicationCheckVos
      };

      this.eprescriberService.approveEprescriber(ieprescriberReviewVo).subscribe
        (success => {
          this.sharedService.showSuccessMessage = success;

          if (this.eprescriber.isTheCurrentUserNurse) {
            this.eprescriberService.isEprescriberReviewCompleted(this.eprescriberId).subscribe(completed => {
              if (completed) {
                this.openPrintOrderModalbutton.nativeElement.click();
              } else
                this.redirectToEprescriber();
            });
          } else
            this.redirectToEprescriber();
        });
    }
    else
      this.loadErrorMessage("Select at least one Medications Check.");

    this.spinnerService.hide();
  }

  closePrintOrderModal() {
    this.exportToPdf();
    this.closePrintOrderModalButton.nativeElement.click();
    this.redirectToEprescriber();
  }

  validateMedicationCheck() {
    if (this.eprescriber.enabledForCurrentUserReview) {
      if (this.eprescriber.nurseReviwer && this.eprescriber.isTheCurrentUserNurse) {
        return this.ieprescriberReviewMedicationCheckVos.length > 0;
      } else
        return true;
    }
    return false;
  }


  redirectToEprescriber() {
    this.spinnerService.hide();

    switch (localStorage.getItem('previousPage')) {
      case "home":
        this.router.navigate(['/']);
        break;
      case "profile":
        this.router.navigate(['patient/profile/' + this.eprescriber.patientId]);
        break;

      default:
        this.router.navigate(['eprescriber/1']);
    }

    if (localStorage.getItem('previousPage').toLowerCase() == 'home')
      this.router.navigate(['/']);
    else
      this.router.navigate(['eprescriber/1']);
  }

  checkBoxChanged(checked, id) {
    if (checked) {
      this.ieprescriberReviewMedicationCheckVos.push({ EprescriberMedicationCheckId: Number.parseInt(id) })
    } else {
      let index = this.ieprescriberReviewMedicationCheckVos.findIndex(i => i.EprescriberMedicationCheckId == id);
      this.ieprescriberReviewMedicationCheckVos.splice(index, 1);
    }
  }

  openReport(id) {
    this.showSuccessMessage = false;
    this.router.navigate(['eprescriber/report/' + id]);
  }

  /** Overwrite weight, height, creatinine Cr/CrCl on patientVo from Connect GetPatientDto when present. */
  private mergeConnectClinicalFromPatientDto(eprescriberData: any): void {
    var patientVo = eprescriberData && eprescriberData.patientVo ? eprescriberData.patientVo : null;
    if (!patientVo) {
      return;
    }
    var pid = eprescriberData.patientId != null ? eprescriberData.patientId : eprescriberData.PatientId;
    if (pid == null || pid === 0) {
      return;
    }
    var self = this;
    this.patientService.getPatient(this.sharedService.pharmacyId, pid).subscribe(
      function (dto) {
        self.applyConnectClinicalToPatientVo(patientVo, dto);
      },
      function () { /* keep portal patientVo values */ }
    );
  }

  private applyConnectClinicalToPatientVo(patientVo: any, dto: any): void {
    if (!patientVo || !dto) {
      return;
    }
    var w = dto.weight != null ? String(dto.weight).trim() : '';
    if (w) {
      patientVo.weight = w;
    }
    var h = dto.height != null ? String(dto.height).trim() : '';
    if (h) {
      patientVo.height = h;
    }
    var cr = dto.creatinineCr != null ? String(dto.creatinineCr).trim() : '';
    if (cr) {
      patientVo.creatinineCr = cr;
    }
    var cl = dto.creatinineCrCl != null ? String(dto.creatinineCrCl).trim() : '';
    if (cl) {
      patientVo.creatinineCrCl = cl;
    }
    var cd = dto.chartDate != null ? String(dto.chartDate).trim() : '';
    if (cd) {
      var parsed = this.parseDtoChartDate(cd);
      if (parsed) {
        patientVo.chartDate = parsed;
      }
    }
  }

  /** Parse Connect chartDate string for `| date` pipe (same source as PMR review). */
  private parseDtoChartDate(raw: string): Date | null {
    var t = raw != null ? String(raw).trim() : '';
    if (!t) {
      return null;
    }
    var ix = t.indexOf('T');
    if (ix > 0 && ix >= 10) {
      t = t.substring(0, 10);
    } else if (t.length >= 10 && t.charAt(4) === '-') {
      t = t.substring(0, 10);
    }
    var d = new Date(t);
    if (isNaN(d.getTime())) {
      return null;
    }
    return d;
  }

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
  }

  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = "";
  }

  public exportToPdf() {
    var pageTitle = "ePrescriberReport";
    this.router.navigate([]).then(result => { window.open('report/eprescriber/' + this.eprescriberId + '/' + pageTitle, '_blank'); });
  }

  getSignature(signaturePath) {
    return this.sharedService.ApiUrl + signaturePath;
  }

  removeEprescriberWorkflowRow(eprescriberWorkflowVo: any) {
    this.clearErrorMessage();
    var workflowId = eprescriberWorkflowVo && eprescriberWorkflowVo.id != null
      ? eprescriberWorkflowVo.id
      : (eprescriberWorkflowVo && eprescriberWorkflowVo.Id != null ? eprescriberWorkflowVo.Id : null);
    if (workflowId == null || workflowId === 0) {
      this.loadErrorMessage('Cannot remove this workflow (missing id).');
      return;
    }
    var roleLabel = eprescriberWorkflowVo && eprescriberWorkflowVo.approver != null ? eprescriberWorkflowVo.approver : '';
    var reviewedByLabel = eprescriberWorkflowVo && eprescriberWorkflowVo.approvedBy != null ? eprescriberWorkflowVo.approvedBy : '';
    var reviewedDateLabel = eprescriberWorkflowVo && eprescriberWorkflowVo.approvedDate != null ? eprescriberWorkflowVo.approvedDate : '';
    var rowSummaryHtml = '<p style="margin:0 0 8px 0;"><strong>Row you are about to remove:</strong></p>' +
      '<p style="margin:0;text-align:left;">' +
      '<strong>Role:</strong> ' + this.escapeHtmlForSwal(roleLabel) + '<br/>' +
      '<strong>Reviewed by:</strong> ' + this.escapeHtmlForSwal(reviewedByLabel) + '<br/>' +
      '<strong>Reviewed date:</strong> ' + this.escapeHtmlForSwal(reviewedDateLabel) +
      '</p>';

    Swal.fire({
      icon: 'warning',
      title: 'Remove this reviewer workflow?',
      html:
        '<p style="margin:0 0 10px 0;">You are about to <strong>permanently delete</strong> this workflow record from the database. This action <strong>cannot be undone</strong>.</p>' +
        rowSummaryHtml +
        '<p style="margin:14px 0 6px 0;text-align:left;"><strong>Before you confirm, you must:</strong></p>' +
        '<ul style="text-align:left;margin:0;padding-left:1.25em;">' +
        '<li>Verify that this is the <strong>correct</strong> reviewer row (role, person, and date).</li>' +
        '<li>Understand that approval history for this ePrescription may change.</li>' +
        '<li>Only proceed if you are <strong>absolutely certain</strong> this entry should be removed.</li>' +
        '</ul>' +
        '<p style="margin:12px 0 0 0;font-weight:600;color:#b71c1c;">If you are not sure, click Cancel and double-check with your supervisor or records.</p>',
      showCancelButton: true,
      focusCancel: true,
      confirmButtonText: 'Yes, remove permanently',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d'
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      var parentEprescriberId = eprescriberWorkflowVo && eprescriberWorkflowVo.eprescriberId != null
        ? eprescriberWorkflowVo.eprescriberId
        : (eprescriberWorkflowVo && eprescriberWorkflowVo.EprescriberId != null ? eprescriberWorkflowVo.EprescriberId : this.eprescriberId);
      this.spinnerService.show();
      this.eprescriberService.removeEprescriberWorkflow(workflowId, parentEprescriberId, this.sharedService.getUserId())
        .subscribe(
          data => {
            this.spinnerService.hide();
            if (data && data.success) {
              this.loadEprescriber();
            } else {
              this.loadErrorMessage((data && data.message) ? data.message : 'Remove failed.');
            }
          },
          () => {
            this.spinnerService.hide();
            this.loadErrorMessage('Remove failed.');
          });
    });
  }

  /** Minimal HTML escape for text shown inside SweetAlert2 html (user-controlled labels). */
  private escapeHtmlForSwal(value: string): string {
    if (value == null || value === '') {
      return '—';
    }
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

